import React from 'react'

import { Container, Header, Title } from './Card.styled'

type Props = {
    title?: string
    children: React.ReactNode
    rightComponent?: React.ReactNode
    style?: React.CSSProperties
} & typeof defaultProps

const defaultProps = {
    title: '',
    rightComponent: <> </>,
    style: {},
}

function Card({ title, children, rightComponent, style, ...props }: Props) {
    return (
        <Container {...props} style={style}>
            {title && (
                <Header>
                    <Title>{title}</Title>
                    {rightComponent}
                </Header>
            )}
            {children}
        </Container>
    )
}

Card.defaultProps = defaultProps

export default Card
